import React,{useState, useRef, useEffect} from 'react'
import Scoreboard from './Scoreboard';
import StartQuiz from './StartQuiz'
let inc=0;
let score=0;
const SportQuiz = (props) => {
  const dataAll=props.name
 
  const [data,setData]=useState(dataAll[inc]);
  const [finish,setFinish] = useState(false);
  const [scr,setscr]= useState(0);
  const [disabled,setDisabled]=useState(false);
  const [qno,setQno]=useState(0);
  
 // const data=props.name
  const [correct,setCorrect]= useState('')
  const prevCountRef = useRef();
  useEffect(() => {
    //assign the ref's current value to the count Hook
    prevCountRef.current = data;
  },[data]);
  const handleChange =(e) => {
    
    setCorrect(e.target.value)
    
  }
  const handleSubmit = (e) => {
   
    if(correct===prevCountRef.current.answer)
    score=score+1;    
    setscr(score)
    console.log(prevCountRef.current.answer+ " " +(!correct)+"score: "+score)  
    setDisabled(true)
   
    if(inc<dataAll.length-1){
        inc=inc+1;      
        setQno(inc);
    }else{
     setFinish(true);
     inc=0
     score=0;
    }

    setData(dataAll[inc])
    e.preventDefault(); 
    setCorrect("");
   
    
  
  }
 if(!finish){
  return (
    <div className='app'>  
    
        <div className="item-container">               
          
        <div className='question'>{data.question}</div>
       <form onSubmit={handleSubmit}>
        <label className='container'><input type="radio" value={data.options[0]} name="gender" checked={correct === data.options[0]} onChange={handleChange}  />{data.options[0]}
        <span className="check"></span></label><br/>
        <label className='container'><input type="radio" value={data.options[1]} name="gender" checked={correct === data.options[1]}  onChange={handleChange} />{data.options[1]}
        <span className="check"></span></label><br/>
        <label className='container'><input type="radio" value={data.options[2]} name="gender" checked={correct === data.options[2]} onChange={handleChange} />{data.options[2]}
        <span className="check"></span></label><br/>
        <label className='container'><input type="radio" value={data.options[3]} name="gender" checked={correct === data.options[3]} onChange={handleChange} />{data.options[3]}
        <span className="check"></span></label><br/>
          <br/> 
          <input type="submit" value="Submit" className='button' disabled={!correct}/>
       
      </form>
     
        </div>
        <div className='quesNo'>{qno+1} / {dataAll.length}</div>
    </div>
 
  )
 }else{
   return(<Scoreboard name={scr} ques={dataAll.length}/>)
 }
}

export default SportQuiz